import { Component, OnInit } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-split-agent-notification-info-success',
  templateUrl: './split-agent-notification-info-success.component.html',
  styleUrls: ['./split-agent-notification-info-success.component.scss'],
  imports: [CdsIconModule, CdsLanguageModule],
})
export class SplitAgentNotificationInfoSuccessComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
